import Button from "../shared/Button";
import styled from "styled-components";
import { media } from "../../styles/mixins";

export const BackgroundWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;

  background-color: ${({ theme }) => theme.colors.modalBackground};
`;

export const JoinGameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  max-width: 512px;
  min-width: 328px;
  max-height: 520px;
  width: 100%;
  height: 100%;

  padding: 48px 16px;
  margin: 64px 16px;

  background-color: ${({ theme }) => theme.colors.background};
  border: 2px solid ${({ theme }) => theme.colors.primary};
  border-radius: 16px;
  box-sizing: border-box;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.16);

  h2 {
    font-size: ${({ theme }) => theme.fonts.sizes.s};
    font-weight: ${({ theme }) => theme.fonts.weights.bolder};
    line-height: ${({ theme }) => theme.fonts.lineHeights.s};
    margin-bottom: 48px;
  }

  ${({ theme }) => media.up("MOBILE")`
    padding: 48px 32px;
    h2 {
      font-size: ${theme.fonts.sizes.l};
    }
  `}
`;

export const Spectator = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 11px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
`;

export const ContinueButton = styled(Button)`
  width: 100%;
  min-height: 48px;
  margin-top: 72px;
  font-family: "sofia-pro";
`;

export const LinksWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
